<template>
  <div class="flex flex-col items-center space-y-24">
    <div
      class="text-static-default-mid body-1 flex md:justify-center"
      :class="{ 'mb-300': !features.repair.enabled }"
    >
      <div class="md:max-w-[700px] md:text-center">
        {{ pageDescription }}
      </div>
    </div>

    <RepairCard
      v-if="features.repair.enabled"
      class="md:min-h-[319px]"
      :tracking-zone="TRACKING_ZONES.NO_POLICIES_OR_ELIGIBLE_INSURANCES"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import RepairCard from '../../components/RepairCard/RepairCard.vue'
import { TRACKING_ZONES } from '../../constant'

import translations from './NoPoliciesOrEligibleInsurances.translations'

const i18n = useI18n()
const { features } = useMarketplace()
const { trackBlockImpression } = useTracking()

const pageDescription = computed(() => {
  return features.repair.enabled
    ? i18n(translations.pageDescriptionWithRepair)
    : i18n(translations.pageDescriptionWithoutRepair)
})

onMounted(() => {
  trackBlockImpression({
    name: 'no-policies-or-eligible-insurances',
    hasRepairAvailable: features.repair.enabled,
  })
})
</script>
